module.exports = __webpack_public_path__ + "img/刘艳丽.d3195e87.jpg";